import React from "react";
import { Text } from "../../core/design-system/Text";
import Button from "../../core/design-system/Button/Button";
import { Img } from "../../core/design-system/Img";

interface TransferDetailsProps {
  transferData: any;
  toggleResultModal: () => void;
}

const TransferDetails: React.FC<TransferDetailsProps> = ({
  transferData,
  toggleResultModal,
}) => {
  const tranferTypes = {
    OWN_ACCOUNT_TRANSFER: "own",
    INTER_BANK_TRANSFER: "inter",
    INTRA_BANK_TRANSFER: "intra",
    INTERNATIONAL_TRANSFER: "international",
  };
  const { toAccount, transactionType, selectedAccount, amount, beneficiary } =
    transferData;
  console.log("selectedAccount:", toAccount, beneficiary);

  return (
    <div className="w-full flex flex-row justify-center items-center  gap-8">
      <div className="flex flex-col w-[326px] h-60 gap-3 opacity-[0px] pt-4 pb-[46px] rounded-lg px-4 shadow-custom p-5 ">
        <Text className="opacity-50 !text-[11px] font-normal leading-[26px] text-left">
          TRANSFERED TO
        </Text>

        <div className="flex flex-row items-center gap-2">
          <div className="w-10 h-10 rounded-3xl bg-lightGray"></div>

          <div className="flex flex-col">
            <Text className="text-[16px] text-base font-medium leading-6 text-left">
              {toAccount.value.name ?? beneficiary.value.name}
            </Text>
            <div className="flex flex-row gap-3">
              <div className="bg-green-200 px-[8px] py-[2px] rounded-xl">
                <Text className="text-[12px] text-green-500 text-base font-medium leading-6 text-left">
                  {Object(tranferTypes)[transactionType]}
                </Text>
              </div>
              <Text className=" text-blue_gray-300 opacity-50 text-xs font-medium leading-6 text-left">
                •••{selectedAccount.value.id.slice(24)}
              </Text>
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-between">
          <Text className="text-darkGray opacity-50 text-sm font-medium leading-[26px] text-left">
            Amount
          </Text>

          <Text className=" text-black-800 text-xs font-medium leading-6 text-left">
            {amount ?? "AED 1000"}
          </Text>
        </div>

        <div className="flex flex-row justify-between">
          <Text className=" text-darkGray opacity-50 text-sm font-medium leading-[26px] text-left">
            Bank
          </Text>

          <Text className=" text-black-800 text-xs font-medium leading-6 text-left">
            {transferData.bankName ?? "Citi Bank"}
          </Text>
        </div>
      </div>
      <div className="flex flex-[0.6] flex-col justify-between  h-60 ">
        <div className="flex flex-col opacity-[0px] gap-3 pt-4 pb-8 rounded-lg px-4 shadow-custom ">
          <Text className="opacity-50 !text-[11px] font-normal leading-[26px] text-left">
            TRANSFERED FROM
          </Text>

          <div className="flex flex-row items-center gap-2">
            <div className="w-10 h-10 rounded-3xl bg-lightGray"></div>

            <div className="flex flex-col">
              <Text className=" text-[16px] text-base font-medium leading-6 text-left">
                {selectedAccount.value.name ?? "Brooklyn Symsons"}
              </Text>
              <div className="flex flex-row ">
                <Text className=" text-blue_gray-300 opacity-50 text-xs font-medium leading-6 text-left">
                  Balance after transfer:
                </Text>

                <Text className="text-black-800 text-xs font-medium leading-6 text-left">
                  {selectedAccount.value.id.slice(24) ?? "TSDB6478171"}
                </Text>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row justify-between p-5 rounded-lg px-4 shadow-custom ">
          <Button variant={"primary"} onClick={toggleResultModal}>
            Make New Transfer
          </Button>

          <Img
            src={"homeSqIcon.svg"}
            className="w-[40px] h-[40px] hover:cursor-pointer"
            onClick={toggleResultModal}
          />
          <Img
            src={"exportSqIcon.svg"}
            className="w-[40px] h-[40px] hover:cursor-pointer"
            onClick={toggleResultModal}
          />
        </div>
      </div>
    </div>
  );
};

export default TransferDetails;
